import React, { useState } from 'react';
import { BadgeCheck } from 'lucide-react';

// Karnataka State Police designations offered at registration.
export const DESIGNATIONS = [
  'Director General of Police (DGP)',
  'Additional Director General of Police (ADGP)',
  'Inspector General of Police (IGP)',
  'Commissioner of Police (CP)',
  'Deputy Inspector General of Police (DIG)',
  'Superintendent of Police (SP)',
  'Deputy Commissioner of Police (DCP)',
  'Additional Superintendent of Police (Addl. SP)',
  'Deputy Superintendent of Police (DySP)',
  'Assistant Commissioner of Police (ACP)',
  'Police Inspector (PI)',
  'Police Sub-Inspector (PSI)',
  'Assistant Sub-Inspector (ASI)',
  'Head Constable (HC)',
  'Police Constable (PC)',
];

const OTHER = '__other__';

/**
 * Designation picker. `value` is the final designation string;
 * choosing "Other" reveals a free-text field.
 */
export default function DesignationSelect({ id, value, onChange }) {
  const [isOther, setIsOther] = useState(!!value && !DESIGNATIONS.includes(value));

  const handleSelect = (e) => {
    if (e.target.value === OTHER) {
      setIsOther(true);
      onChange('');
    } else {
      setIsOther(false);
      onChange(e.target.value);
    }
  };

  return (
    <div className="space-y-2">
      <div className="relative">
        <BadgeCheck className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" aria-hidden="true" />
        <select
          id={id}
          value={isOther ? OTHER : value}
          onChange={handleSelect}
          className="login-input"
          required
        >
          <option value="" disabled>Select your designation</option>
          {DESIGNATIONS.map((d) => (
            <option key={d} value={d}>{d}</option>
          ))}
          <option value={OTHER}>Other (specify)</option>
        </select>
      </div>
      {isOther && (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="login-input"
          style={{ paddingLeft: '0.75rem' }}
          placeholder="Enter your designation"
          maxLength={100}
          aria-label="Other designation"
          required
        />
      )}
    </div>
  );
}
